class VariantListener extends HTMLElement {
  constructor() {
    super();
    window.loaders = window.loaders || {};
    this.loading = {};
    this.sectionUrl = this.dataset.sectionUrl || window.location.pathname;
    this.root = document.querySelector(
      `[data-root="${this.dataset.rootId}"]`
    );
    if (this.root && this.root.closest("main-product")) {
      this.currentVariantId = this.root.closest("main-product").getAttribute("data-variant-id");
    }
    this.media_change = this.dataset.mediaChange === "true" || false;
    if (this.dataset.valueLookup) {
      this.valueLookup = JSON.parse(this.dataset.valueLookup) || [];
      let resData = {};
      this.valueLookup.forEach((data) => {
        const node = this.querySelector(`[data-value="${data}"]`);
        if (node) {
          resData[data] = node.innerHTML;
        }
        this.inputs = {
          ...this.inputs,
          [data]: this.querySelectorAll(`[data-value="${data}"]`),
        };
      });
    }
    if (this.valueLookup && this.inputs) {
      this.root.addEventListener("variant-change", this.changeValue.bind(this));
    }
    document.addEventListener("reload-variant-listener", async () => {
      await this.reloadSnippet(this.currentVariantId);
    });
  }
  async fetchSectionData(variantId) {
    if(this.loading[variantId] !== true){
    window.loaders[variantId] = new Promise(async (resolve) => {
      this.loading[variantId] = true
      const res = await fetch(`${this.sectionUrl}?variant=${variantId}`);
      const textRest = await res.text();
      const html = new DOMParser().parseFromString(textRest, "text/html");
      this.loading[variantId] = false
      resolve(html);
    });
    }
  }

  getRenderData(variantId, html) {
    let resData = {};
    this.valueLookup.forEach((value) => {
      const node = html.querySelector(`[data-value="${value}"]`);
      if (node) {
        resData[value] = node.innerHTML;
      }
    });
    this.dataObject = { ...this.dataObject, [variantId]: resData };
  }

  async changeValue(evt) {
    this.currentVariantId = evt.detail.currentVariant.id;
    const variantId = evt.detail.currentVariant.id;
    if (
      !variantId ||
      (this.media_change === true && evt.detail.shouldChangePdpMedia !== true)
    )
      return;
    if (!window.loaders[variantId]) {
      await this.fetchSectionData(variantId);
    }
    await this.parseHtml(variantId);
  }

  async reloadSnippet(variantId) {
    await this.fetchSectionData(variantId);
    await this.parseHtml(variantId);
  }
  async parseHtml(variantId) {
    const html = await window.loaders[variantId];
    if (!html) return;
    this.getRenderData(variantId, html);
    const dataValues = this.dataObject[variantId];
    this.valueLookup.forEach((data) => {
      if (!this.inputs[data]) return;
      this.inputs[data].forEach((inputNode) => {
        if (dataValues[data]) {
          const currentHeight = this.getCurrentContainerHeight(inputNode);
          inputNode.innerHTML = dataValues[data];
          let height = 0;
          if (inputNode.dataset.updateParentHeight === "true") {
            height = currentHeight + inputNode.offsetHeight;
            inputNode.parentElement.style.height = height + "px";
          }
        }
      });
    });
  }
  getCurrentContainerHeight(inputNode) {
    if (!inputNode) return;
    let currentHeight = 0;
    for (const element of inputNode.parentElement.children) {
      currentHeight += element.offsetHeight;
    }
    return currentHeight - inputNode.offsetHeight;
  }
}
customElements.define("variant-listener", VariantListener);
